export const foreignKeyMapping = {
  contacts: "contact_id",
  companies: "company_id",
  deals: "deal_id",
  partners: "partner_id",
};
